import React, { useMemo } from 'react'
import { Button } from '@ow/comps'
import { useTbViewStore } from '@vt/hooks'
import { pick } from 'lodash-es'
import BatchAdd from './batchAdd'
import BatchDelete from './batchDelete'
import Tree from './tree'
import BindModal from './binding/bindModal'
import { useBindLevel } from './binding/utils'
import CheckedIcon from './checkedIcon'
import useAreaStore from './areaStore'
import Exporter from './exporter'

const Control = function ({ type }) {
  const { isCreateAreaBind, isBatchDelete, objectIdsBindedList, setAreaState } =
    useAreaStore((state) =>
      pick(state, [
        'isCreateAreaBind',
        'isBatchDelete',
        'objectIdsBindedList',
        'setAreaState',
      ])
    )

  const { setTbData, tbData, tbDefs, selectedIds } = useTbViewStore((state) =>
    pick(state, ['setTbData', 'tbDefs', 'tbData', 'selectedIds'])
  )

  // 要求远洋点位管理，显示“城市“
  const title = type === 'area' ? tbDefs.tbName : '指标'

  const tbDataWithIcon = useMemo(() => {
    if (!objectIdsBindedList.length) return tbData
    return tbData.map((item) => ({
      ...item,
      icon: objectIdsBindedList.includes(item.objectId) ? (
        <CheckedIcon />
      ) : null,
    }))
  }, [tbData, objectIdsBindedList])

  // eslint-disable-next-line no-unused-vars
  const startDelete = () => {
    setAreaState({ isBatchDelete: true })
  }

  const levelType = useBindLevel()

  const isNormal = !isCreateAreaBind && !isBatchDelete
  const isMulti = isCreateAreaBind && levelType === 'isLastLevel'

  return (
    <div>
      <div className="pt-5 pb-3.5 px-3 flex justify-between flex-wrap">
        <div>{title}管理</div>
        <div className="flex items-center gap-2 flex-wrap">
          {isNormal && (
            <>
              <BatchAdd
                title={title}
                type={type}
                refreshTreeData={(data) => {
                  setTbData(tbDataWithIcon.concat(data))
                }}
              >
                <Button className="h-6" type="primary" size="sm">
                  添加{title}
                </Button>
              </BatchAdd>
              <Button className="h-6" size="sm" stroke onClick={startDelete}>
                批量删除
              </Button>
            </>
          )}
          {isMulti && (
            <BindModal isMulti>
              <Button
                className="h-6"
                size="sm"
                stroke
                disabled={selectedIds.length === 0}
              >
                批量绑定
              </Button>
            </BindModal>
          )}
          {isBatchDelete && <BatchDelete type="area" />}
          <Exporter type="点位" />
        </div>
      </div>
      <Tree
        tbData={tbDataWithIcon}
        checkable={isBatchDelete || isMulti}
        checkStrictly={isBatchDelete}
      />
    </div>
  )
}

export default Control
